import { useEffect, useState } from 'react';

import { useDispatch } from 'react-redux';

import { useParams } from 'react-router';

import { Box, Button, Card, CardContent, CardHeader, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, Grid, Paper, Tab, Tabs, Typography } from '@mui/material';

import moment from 'moment';

import { TabPanel, TabProps } from '../../../helpers/TabPanel';

import { openSnackbar } from '../../../store/slices/SnackbarSlice';

import { DialogActionsStyle, DialogContentStyle } from '../../../styles/DialogStyle';

import { Layout } from '../../../components/Layout'
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxHeaderInformacion } from '../../../components/BoxHeaderInformacion';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { BoxInformacionExpediente } from '../../../components/BoxInformacionExpediente';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';
import { InfoField } from '../../../components/InfoField';

import { Notificacion } from '../ui/Notificacion';

import { IncidentesPendientes } from '../../../connections/tribunal/IncidenteConnection';
import { ObtenerSentidoFallo } from '../../../connections/catalogos/SentidoFalloConnection';
import { ObtenerMediosImpugnacionSentencia } from '../../../connections/tribunal/MedioImpugnacionConnection';
import { ActualizarEstatusSentecia, DetalleSentencia } from '../../../connections/sentencia/SentenciaConnection';

import { SentidoFalloProps } from '../../../interfaces/catalogos/SentidoFalloInterface';
import { NotificacionesProps } from '../../../interfaces/notificaciones/NotificacionesInterface';
import { defaultIncidente, IncidenteProps } from '../../../interfaces/tribunal/IncidenteInterface';
import { defaultMedioImpugnacion, MedioImpugnacionProps } from '../../../interfaces/tribunal/MedioImpugnacionInterface';
import { defaultSentencia, SentenciaProps } from '../../../interfaces/sentencia/SentenciaInterface';

const chipStyle = {
    display: 'flex', flexDirection: 'column', gap: 0.5,
    flex: 1,
    px: 2, py: 1,
    borderRadius: 1,
    backgroundColor: 'action.hover',
    border: '1px solid',
    borderColor: 'divider',
} as const;

export const VisualizarSentenciaPage = () => {

    const dispatch = useDispatch();

    const { Id } = useParams();

    const [value, setValue] = useState( 0 );

    const [sentencia, setSentencia] = useState<SentenciaProps>( defaultSentencia )

    const [loading, setLoading] = useState( true );
    const [loadingFinalizar, setLoadingFinalizar] = useState( false );

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [openDialogConfirmacionFinalizar, setOpenDialogConfirmacionFinalizar] = useState( false );

    const [notificaciones, setNotificaciones] = useState<NotificacionesProps[]>( [] );

    const [resuelveRecurso, setResuelveRecurso] = useState( false );
    const [medioImpugnacion, setMedioImpugnacion] = useState( 0 );
    const [medioImpugnacionArray, setMedioImpugnacionArray] = useState<MedioImpugnacionProps[]>( [] );

    const [sentidoFallo, setSentidoFallo] = useState( 0 );
    const [sentidoFalloArray, setSentidoFalloArray] = useState<SentidoFalloProps[]>( [] );

    const [resuelveIncidente, setResuelveIncidente] = useState( false );
    const [incidente, setIncidente] = useState( 0 );
    const [incidenteArray, setIncidenteArray] = useState<IncidenteProps[]>( [] );

    const { tipoRecurso, tipoResolucion, recurrente, fechaAdmision } =
        medioImpugnacionArray.find( ({ idMedioImpugnacion }) => idMedioImpugnacion === medioImpugnacion ) ?? defaultMedioImpugnacion;

    const { secretario, fecha } =
        incidenteArray.find( ({ idIncidente }) => idIncidente === incidente ) ?? defaultIncidente;

    const handleChange = ( _: React.SyntheticEvent, newValue: number ) => setValue( newValue )

    const handleFinalizar = async () => {

        setLoadingFinalizar( true );

        await ActualizarEstatusSentecia({ idSentencia: Id ?? '', idEstatus: 3, observaciones: '' }).then(resp => {

            setTimeout(() => {

                const { success, message } = resp;

                if ( success ) {

                    setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                    setProcesoTerminado( true );
                    setLoadingFinalizar( false );

                }
                else {

                    dispatch(openSnackbar({ message: message, variant: 'error' }));
                    setLoadingFinalizar( false );

                }

            }, 700);

        });

    }

    useEffect(() => {

        setLoading( true );

        async function Obtener() {

            await DetalleSentencia( Id ?? '' ).then(resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if ( success ) {

                        setSentencia( resp );
                        setNotificaciones( resp.notificaciones );

                        setResuelveRecurso( resp.resuelveRecurso );
                        setMedioImpugnacion( resp.idMedioImpugnacion );
                        setSentidoFallo( resp.idSentidoFallo );

                        setResuelveIncidente( resp.resuelveIncidente );
                        setIncidente( resp.idIncidente );

                        if ( resp.idEstatus === 3 ) {
                            setMensajeFinalizacion('No se tienen actividades pendientes para este trámite');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.idEstatus === 4 ) {
                            setProcesoCancelado( true );
                            setLoading( false );
                        }
                        else if ( !resp.asignadoMismoUsuario ) {
                            setMensajeAsignacion(`La siguiente actividad se asignó a ${ resp.usuarioAsignado }`);
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus !== 39 ) {
                            setMensajeAsignacion('La siguiente actividad se encuentra en tu bandeja');
                            setProcesoTerminado( true );
                            setLoading( false );
                        }
                        else if ( resp.asignadoMismoUsuario && resp.idEstatus === 39 ) {
                            setLoading( false );
                        }
                    }
                    else {

                        setProcesoNoEncontrado( true );
                        setLoading( false );

                    }

                }, 700);

            });

        }

        Obtener();

    }, [ Id ])

    useEffect(() => {

        async function Obtener() {

            await ObtenerSentidoFallo().then(resp => {
                setSentidoFalloArray( resp );
            });

        }

        Obtener();

    }, []);

    useEffect(() => {

        async function Obtener() {

            await ObtenerMediosImpugnacionSentencia({ idExpediente: sentencia.idExpediente }).then(resp => {
                setMedioImpugnacionArray( resp );
            });

        }

        if ( resuelveRecurso && sentencia.idExpediente !== 0 ) {
            Obtener();
        }

    }, [ resuelveRecurso, sentencia.idExpediente ]);

    useEffect(() => {

        async function Obtener() {

            await IncidentesPendientes({ idExpediente: sentencia.idExpediente }).then(resp => {
                setIncidenteArray( resp );
            });

        }

        if ( resuelveIncidente && sentencia.idExpediente !== 0 ) {
            Obtener();
        }

    }, [ resuelveIncidente, sentencia.idExpediente ]);

    return (
        <Layout breadcrumbs={ [{ text: 'Sentencia' }, { text: 'Visualizar sentencia' }] } backgroundPaper={ ( procesoTerminado || procesoCancelado || procesoNoEncontrado ) }>

            {
                loading
                ?
                    <Box component={ Paper } height={ '70vh' } textAlign={ 'center' } alignContent={ 'center' } alignItems={ 'center' }>
                        <CircularProgressIndicator />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAssing={ mensajeAsignacion } processEnd={ sentencia.idEstatus === 3 } />
                        :
                            <>

                                <Box sx={{ borderBottom: 1, borderColor: 'divider' }}>

                                    <Tabs value={ value } onChange={ handleChange }>

                                        <Tab label='Sentencia' {...TabProps(0)} />
                                        <Tab label='Notificación' {...TabProps(1)} />
                                        <Tab label="Información del expediente" {...TabProps(2)} />

                                    </Tabs>

                                </Box>

                                <TabPanel value={ value } index={ 0 }>

                                    <Box p={ 4 } component={ Paper }>

                                        <BoxHeaderInformacion
                                            numeroSeguimiento={ `GSE-${ sentencia.idSentencia }` }
                                            fecha={ sentencia.fecha ?? new Date() }
                                            juez={ sentencia.juez }
                                        />

                                        <Grid container spacing={ 3 } mt={ 2 }>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Número de Sentencia (Resolución)"
                                                    value={ sentencia.numeroSentencia }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Tipo de Sentencia"
                                                    value={ `Sentencia ${ sentencia.tipoSentencia }` }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Fecha de citación"
                                                    value={ sentencia.fechaCitacion ? moment( sentencia.fechaCitacion ).format('DD-MM-YYYY hh:mm a') : '' }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="Sentido de sentencia"
                                                    value={ sentencia.sentidoSentencia }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}>

                                                <InfoField
                                                    chip
                                                    label="¿Con perspectiva género?"
                                                    value={ sentencia.perspectivaGenero ? 'Si' : 'No' }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 6, xs: 12 }}> </Grid>

                                            {
                                                sentencia.plantilla
                                                &&
                                                    <Grid size={{ md: 6, xs: 12 }}>

                                                        <InfoField
                                                            chip
                                                            label="Plantilla"
                                                            value={ sentencia.plantilla }
                                                        />

                                                    </Grid>
                                            }

                                            {
                                                ( sentencia?.idTipoSentencia === 2 && sentencia?.medioImpugnacion === true )
                                                &&
                                                    <>
                                                        <Grid size={{ md: 12, xs: 12 }}>

                                                            <InfoField
                                                                chip
                                                                label="¿La sentencia resuelve un recurso?"
                                                                value={ resuelveRecurso ? 'Si' : 'No' }
                                                            />

                                                        </Grid>

                                                        {
                                                            resuelveRecurso
                                                            &&
                                                                <Grid size={{ md: 12, xs: 12 }} >

                                                                    <Card>

                                                                        <CardHeader
                                                                            sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                                            subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del recurso </Typography> }
                                                                        />

                                                                        <Divider />

                                                                        <CardContent>

                                                                            <Grid container spacing={ 3 }>

                                                                                <Grid size={{ md: 12, xs: 12 }} mt={ 1 }>

                                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                        <Box sx={ chipStyle }>
                                                                                            <Typography variant='caption' color='text.secondary'>Tipo de recurso</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{tipoRecurso}</Typography>
                                                                                        </Box>

                                                                                        <Box sx={ chipStyle }>
                                                                                            <Typography variant='caption' color='text.secondary'>Resolución</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{tipoResolucion}</Typography>
                                                                                        </Box>

                                                                                        <Box sx={ chipStyle }>
                                                                                            <Typography variant='caption' color='text.secondary'>Fecha de admisión</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>
                                                                                                {fechaAdmision ? moment(fechaAdmision).format('DD-MM-YYYY') : ''}
                                                                                            </Typography>
                                                                                        </Box>

                                                                                        <Box sx={{ ...chipStyle, flex: 2 }}>
                                                                                            <Typography variant='caption' color='text.secondary'>Recurrente</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{recurrente}</Typography>
                                                                                        </Box>

                                                                                    </Box>

                                                                                </Grid>

                                                                                <Grid size={{ md: 12, xs: 12 }} >

                                                                                    <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                        <Box sx={ chipStyle }>
                                                                                            <Typography variant='caption' color='text.secondary'>Sentido del fallo</Typography>
                                                                                            <Typography variant='body2' fontWeight='bold'>{sentidoFalloArray.find(({ idSentidoFallo }) => idSentidoFallo === sentidoFallo)?.descripcion ?? ''}</Typography>
                                                                                        </Box>

                                                                                    </Box>

                                                                                </Grid>

                                                                            </Grid>

                                                                        </CardContent>

                                                                    </Card>

                                                                </Grid>
                                                        }

                                                    </>
                                            }

                                            {
                                                ( sentencia?.idTipoSentencia === 2 && sentencia?.incidente === true )
                                                &&
                                                    <Grid size={{ md: 12, xs: 12 }} >

                                                        <Card>

                                                            <CardHeader
                                                                sx={{ backgroundColor: (theme) => theme.palette.primary.main }}
                                                                subheader={ <Typography sx={{ fontWeight: '400', color: 'white' }}> Información del incidente </Typography> }
                                                            />

                                                            <Divider />

                                                            <CardContent>

                                                                <Grid container spacing={ 3 }>

                                                                    <Grid size={{ md: 12, xs: 12 }} >

                                                                        <InfoField
                                                                            chip
                                                                            label="¿La sentencia resuelve un incidente?"
                                                                            value={ resuelveIncidente ? 'Si' : 'No' }
                                                                        />

                                                                    </Grid>

                                                                    {
                                                                        resuelveIncidente
                                                                        &&
                                                                            <Grid size={{ md: 12, xs: 12 }} >

                                                                                <Box sx={{ display: 'flex', justifyContent: 'space-between', width: '100%', gap: 1.5 }}>

                                                                                    <Box sx={ chipStyle }>
                                                                                        <Typography variant='caption' color='text.secondary'>Secretario(a)</Typography>
                                                                                        <Typography variant='body2' fontWeight='bold'>{secretario}</Typography>
                                                                                    </Box>

                                                                                    <Box sx={ chipStyle }>
                                                                                        <Typography variant='caption' color='text.secondary'>Fecha</Typography>
                                                                                        <Typography variant='body2' fontWeight='bold'>
                                                                                            {fecha ? moment(fecha).format('DD-MM-YYYY') : ''}
                                                                                        </Typography>
                                                                                    </Box>

                                                                                </Box>

                                                                            </Grid>
                                                                    }

                                                                </Grid>

                                                            </CardContent>

                                                        </Card>

                                                    </Grid>
                                            }

                                            <Grid size={{ md: 12, xs: 12 }}>

                                                <iframe
                                                    title='iframe-documento'
                                                    style={{ width: '100%', height: 800, borderRadius: 8 }}
                                                    src={ sentencia.documento }
                                                />

                                            </Grid>

                                            <Grid size={{ md: 12, xs: 12 }} sx={{ mt: 3 }}>

                                                <Grid container spacing={ 3 }>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'left' }}> </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} style={{ textAlign: 'center' }}>
                                                        <Button
                                                            fullWidth
                                                            color='primary'
                                                            variant='contained'
                                                            onClick={ () => setOpenDialogConfirmacionFinalizar( true ) }
                                                        >
                                                            Finalizar
                                                        </Button>
                                                    </Grid>

                                                    <Grid size={{ md: 4, xs: 12 }} sx={{ textAlign: 'right' }}> </Grid>

                                                </Grid>

                                            </Grid>

                                        </Grid>

                                    </Box>

                                </TabPanel>

                                <TabPanel value={ value } index={ 1 }>

                                    <Notificacion sentencia={ sentencia } notificaciones={ notificaciones } setNotificaciones={ setNotificaciones } edit={ false } />

                                </TabPanel>

                                <TabPanel value={ value } index={ 2 }>

                                    <BoxInformacionExpediente
                                        expediente={ sentencia.expediente }
                                    />

                                </TabPanel>

                                <Dialog
                                    fullWidth
                                    maxWidth='xs'
                                    open={ openDialogConfirmacionFinalizar }
                                    onClose={ () => { } }
                                >

                                    <DialogTitle>
                                        Confirmación
                                    </DialogTitle>

                                    <DialogContent sx={ DialogContentStyle }>

                                        <DialogContentText>
                                            ¿Desea finalizar la visualizacion de la sentencia?
                                        </DialogContentText>

                                    </DialogContent>

                                    <DialogActions sx={ DialogActionsStyle }>
                                        <Button color="secondary" disabled={ loadingFinalizar } onClick={ () => setOpenDialogConfirmacionFinalizar(false) }> Cancelar </Button>
                                        <Button loading={ loadingFinalizar } onClick={ () => handleFinalizar() } variant='contained' > Aceptar </Button>
                                    </DialogActions>
                                </Dialog>
                            </>
            }

        </Layout>
    )
}
